import {
  Button,
  Input,
  Carousel,
  Typography,
  Layout,
  Col,
  Row,
  Tag,
  Segmented,
} from "antd";
import styled, { keyframes } from "styled-components";

const { Title, Text } = Typography;
const { Content } = Layout;

const { Search } = Input;

export const StyledContent = styled(Content)`
  height: 100%;
  background: whitesmoke;
  overflow-y: hidden;
  background-image: url("/Mask group.png");
  background-size: cover;
  z-index: 1;
`;

export const StyledModalSpan = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px groove #192238;
  box-shadow: 1 1 1;
`;

export const StyledModalTag = styled(Tag)`
  font-family: Inter;
  font-weight: 600;
  font-size: 14;
  align-content: center;
`;

export const StyledDateText = styled(Text)`
  margin-top: 10px;
  font-family: Inter;
  font-size: 13px;
  color: grey;
`;
export const StyledSearch = styled(Search)`
  width: 40%;
  margin-bottom: 10px;
  margin-top: 10px;
  font-family: "Lota";

  &.ant-input-search {
    .ant-input-group {
      .ant-input-affix-wrapper:not(:last-child),
      .ant-input-group-addon:first-child,
      .ant-input:first-child {
        height: 50px;
        display: flex;
        align-items: center;

        @media (max-width: 576px) {
          height: 40px;
          font-size: 14px;
        }
      }
      .ant-input-group-addon:last-child .ant-input-search-button {
        height: 50px;
        background-color: #b80000;
        color: white;

        @media (max-width: 576px) {
          height: 40px;
          font-size: 14px;
        }
      }
    }
  }
`;

export const StyledCarousel = styled(Carousel)`
  width: 100%;
  background-image: url("blue.png");
  height: 95vh;
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const StyledTitle = styled(Title)`
  &:where(.css-dev-only-do-not-override-xu9wm8).ant-typography,
  div:where(.css-dev-only-do-not-override-xu9wm8).ant-typography-h2,
  div:where(.css-dev-only-do-not-override-xu9wm8).ant-typography-h2 > textarea,
  :where(.css-dev-only-do-not-override-xu9wm8).ant-typography h2 {
    font-size: 42px;
    text-align: left;
    margin-left: 20px;
    margin-top: 70px;
    color: white;
  }
`;

export const StyledText = styled(Text)`
  font-weight: 500;
  font-family: "Lato";
  font-size: 16px;
  font-weight: 700;
  color: #005461;
  /* margin-left: 35px; */
`;

export const StyledBackButton = styled(Button)`
  &&.ant-btn-text {
    margin-top: 20px;
    height: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;

    &:hover {
      background-color: white;
      border-color: white;
      /* color: #192238; */
    }
  }
`;

export const StyledSearchbar = styled(Content)`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const StyledNewsExport = styled(Content)`
  display: flex;
  height: 100%;
  justify-content: center;
  align-content: center;
`;

export const StyledSearchCol = styled(Col)`
  display: flex;
  justify-content: flex-start;
  /* margin-left: 25px; */
  /* margin-top: 30px; */
`;

export const StyledContentCol = styled(Col)`
  background: white;

  height: 93vh;
  border-right: 0.5px solid lightgrey;

  @media (max-width: 1366px) {
    height: 95vh;
  }
`;

export const StyledNewsCol = styled(Col)`
  /* height: 80vh; */
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
`;

export const StyledBarButton = styled(Button)`
  &&.ant-btn-primary {
    /* background-image: linear-gradient(to right, red, purple); */
    border-color: #005461;
    background: #005461;
    color: white;
    border: none;
    box-shadow: none;
    border-radius: 5px;
    /* margin-left: 10px; */
    /* padding: 0 20px; */
    /* height: 50px;
    font-size: 20px; */
    text-align: center;
    transition: color 0.2s ease;
    display: "flex";
    justify-content: center;
    align-items: center;

    font-weight: 500;

    @media (min-width: 769px) {
      height: 50px;
      font-size: 20px;
      width: 100px;
    }
    &:hover {
      /* background-image: linear-gradient(to right, purple, red); */
      background-color: #005461;
      border-color: #005461;
      border: 1px solid #005461;
      color: white;
      transition: background-image 0.5s ease, color 0.1s ease;
    }
  }
`;

export const StyledNewsRow = styled(Row)`
  background-color: white-smoke;
  @media (max-width: 750px) {
    height: 100vh;
    /* overflow-y: auto; */
  }
  @media (min-width: 700px) {
    height: 100%;
  }
`;

export const StyledNewsPageGenerateButton = styled(Button)`
  &&.ant-btn-primary {
    font-family: Lato;
    font-size: 16px;
    width: 130px;
    padding: 20px;
    border-radius: 49px;
    line-height: 18px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #b80000;
    border-color: #b80000;
    color: white;
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #b80000;
      color: #b80000;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

const popAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  30% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  70% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const StyledTutorialButton = styled(Button)`
  &&.ant-btn-primary {
    font-family: Lato;
    font-size: 16px;
    width: 130px;
    padding: 20px;
    border-radius: 49px;
    line-height: 18px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border-color: #b80000;
    color: #b80000;
    font-family: "Lato";
    animation: ${popAnimation} 5s ease-out;

    &:hover {
      background-color: #b80000;
      border-color: #b80000;
      color: white;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledSegmented = styled(Segmented<string>)`
  && .ant-segmented-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  && .ant-segmented-item-label {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  && .ant-segmented-item-selected {
    background-color: #b80000 !important;
    color: white !important;

    .ant-segmented-item-label {
      color: white !important;
    }
  }

  && .ant-segmented-item:hover:not(.ant-segmented-item-selected) {
    color: #b80000;
  }

  @media (max-width: 576px) {
    && .ant-segmented-item {
      padding: 4px 8px;
      min-width: 36px;
    }

    && .ant-segmented-item-label {
      font-size: 12px;
    }
  }
`;

export const StyledMainContent = styled(Content)`
  height: 100%;
  /* background: red; */
  background-image: url("/Mask group.png");

  background-size: cover;
  overflow-y: auto;
  z-index: 1;
  /* margin-top: 70px; */
  /* Hide scrollbar for Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const StyledCardContent = styled(Content)`
  /* height: 73.5vh; */
  overflow-y: auto;
  /* Hide scrollbar for Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;
